export const check = {
    companyId: "",
    masterId: 0,
    enable: false,
    xWebId: "",
    apiKey:"",
    merchantId:"",
    webToken:"",
    terminalId: "",
    authKey: "",
    termsAndConditions: "",
    staxEnable: false,
};


export interface OpenEdgePaymentData {
    companyId: string | null;
    masterId: number | null;
    enable: boolean;
    authKey: string | null;
}


export const objError = {
    xWebId: {
        status: false,
        message: "",
    },
    terminalId: {
        status: false,
        message: "",
    },
    authKey: {
        status: false,
        message: "",
    },
    apiKey: {
        status: false,
        message: "",
    },
    webToken: {
        status: false,
        message: "",
    },
    merchantId: {
        status: false,
        message: "",
    }
};

export const WEB_TOKEN_ID = "webToken";
export const MERCHANT_ID = "merchantId";
export const API_KEY = "apiKey";
export const WEB_TOKEN_ID_MANDATORY = "Web Token is mandatory";
export const MERCHANT_ID_MANDATORY = "Merchant ID is mandatory";
export const API_KEY_MANDATORY = "Api Key is mandatory";
export const DETAILS_INVALID = "Details do not match, try again";
export const STAX = "STAX";
export const STAX_TITLE = "Successware Payment";
export const STAX_ENABLED_MESSAGE = "Successware Payment option has been successfully enabled";
export const STAX_DISABLED_MESSAGE = "Successware Payment option has been successfully disabled";
